/*
  L'assistant de demandes — sections/contact-form.liquid (03/10/2026).

  Un parcours par type, chacun avec ce qu'il faut pour qu'on puisse répondre du
  premier coup : la commande retrouvée (n° + e-mail) pour un suivi, un retour
  ou un problème, les conditions de retour cochées une à une, des photos là où
  on ne peut rien décider sans elles.

  ⚠️ CE QUE L'ASSISTANT AFFICHE N'EST QU'UNE PRÉVISUALISATION. Le serveur
  (pbs_vente/api/demandes.py, dépôt probikestock) refait chaque vérification à
  l'envoi : on ne fait pas confiance à une page qu'on peut modifier.

  ⚠️ SEULES LES COMMANDES DE LA BOUTIQUE (03/10/2026, décision d'Antoine) : un
  achat Vinted, Leboncoin ou Buycycle se règle sur sa plateforme, l'assistant
  ne le connaît pas.

  Les valeurs envoyées (type, motifs) sont les libellés FRANÇAIS, quelle
  que soit la langue affichée : c'est ce que lit l'admin.
*/
(function () {
  'use strict';

  var racine = document.getElementById('PbsDemande');
  if (!racine) return;
  var T = JSON.parse(document.getElementById('PbsDemandeTextes').textContent);
  var MES_COMMANDES = JSON.parse(document.getElementById('PbsDemandeCommandes').textContent || '[]');
  var API = racine.dataset.api;
  var LANGUE = racine.dataset.langue || 'fr';

  // Les valeurs envoyées, en français ; l'affichage vient de T.
  var MOTIFS_RETOUR = ['Ne convient pas', 'Erreur de commande', "Changement d'avis", 'Autre'];
  var NATURES = ['Abîmé ou cassé', 'Article erroné', 'Article manquant', 'Ne fonctionne pas', 'Autre'];
  var SOUCIS = ['Pas reçu', 'Bloqué en transit', 'Livré mais introuvable', 'Autre'];
  var ETATS = ['Neuf', 'Comme neuf', 'Occasion, bon état', 'Occasion, usé'];
  var AVEC_COMMANDE = ['Suivi', 'Retour', 'Probleme'];

  // Une icône par carte (04/10/2026), au trait 1,8 dans une grille 24 — celui
  // de la loupe, du globe et du panier de l'en-tête. On repère son cas sans
  // lire les six libellés.
  var TRAITS = 'fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"';
  var ICONES = {
    Suivi: '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    Retour: '<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/>',
    Probleme: '<path d="M12 3.5 2.5 20h19z"/><path d="M12 10v4.5M12 17.2v.3"/>',
    Produit: '<path d="M4 5h16v11H9l-5 4z"/><path d="M10 9.2a2 2 0 1 1 2.8 1.8c-.6.3-.8.7-.8 1.3M12 14.3v.2"/>',
    Reprise: '<path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8" r="1.4"/>',
    Autre: '<circle cx="5" cy="12" r="1.3"/><circle cx="12" cy="12" r="1.3"/><circle cx="19" cy="12" r="1.3"/>'
  };
  function icone(k) {
    return '<span class="pbs-demande__icone" aria-hidden="true"><svg viewBox="0 0 24 24" ' + TRAITS + '>' +
      (ICONES[k] || '') + '</svg></span>';
  }
  var PHOTOS_OBLIGATOIRES = ['Retour', 'Probleme'];
  var COTE_MAX = 1800;

  var etat = {
    type: '', cmd: null, saisie: '',
    email: racine.dataset.email || '', nom: racine.dataset.nom || '',
    photos: []
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmt(s, v) {
    return String(s).replace(/\{(\w+)\}/g, function (_, k) { return v[k] != null ? v[k] : ''; });
  }
  function dateFr(iso) {
    if (!iso) return '';
    var p = iso.split('-');
    return p[2] + '/' + p[1] + '/' + p[0];
  }
  function $(sel) { return racine.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(racine.querySelectorAll(sel)); }

  function afficher(html) {
    racine.innerHTML = html;
    var premier = racine.querySelector('input:not([type=hidden]):not([type=checkbox]), select, textarea');
    if (premier && document.activeElement !== premier && racine.dataset.focus) premier.focus({ preventScroll: true });
    racine.dataset.focus = '1';
    var haut = racine.getBoundingClientRect().top + window.scrollY - 120;
    if (window.scrollY > haut) window.scrollTo({ top: haut, behavior: 'smooth' });
  }

  function retourBouton(cible) {
    return '<button type="button" class="pbs-demande__precedent link" data-aller="' + cible + '">← ' + esc(T.retour) + '</button>';
  }

  // ── Champs ────────────────────────────────────────────────────────────────
  function champ(nom, libelle, opts) {
    opts = opts || {};
    var id = 'PbsD-' + nom;
    var attrs = (opts.requis ? ' required' : '') + (opts.type ? ' type="' + opts.type + '"' : ' type="text"') +
      (opts.auto ? ' autocomplete="' + opts.auto + '"' : '');
    if (opts.zone) {
      return '<div class="field"><textarea class="text-area field__input" rows="5" id="' + id + '" name="' + nom + '"' +
        (opts.requis ? ' required' : '') + ' placeholder="' + esc(libelle) + '">' + esc(opts.valeur || '') + '</textarea>' +
        '<label class="field__label" for="' + id + '">' + esc(libelle) + (opts.requis ? ' *' : '') + '</label></div>';
    }
    return '<div class="field"><input class="field__input" id="' + id + '" name="' + nom + '"' + attrs +
      ' value="' + esc(opts.valeur || '') + '" placeholder="' + esc(libelle) + '">' +
      '<label class="field__label" for="' + id + '">' + esc(libelle) + (opts.requis ? ' *' : '') + '</label></div>' +
      // L'aide SOUS le champ, hors du `.field` : Dawn le met en flex, et elle
      // se collait à droite de la saisie, sur trois lignes (04/10/2026).
      (opts.aide ? '<small class="pbs-demande__note pbs-demande__note--champ">' + esc(opts.aide) + '</small>' : '');
  }

  function liste(nom, libelle, valeurs, libelles, requis) {
    var o = '<option value="" disabled selected>—</option>';
    valeurs.forEach(function (v, i) { o += '<option value="' + esc(v) + '">' + esc(libelles[i]) + '</option>'; });
    return '<div class="pbs-demande__champ"><label class="pbs-demande__label" for="PbsD-' + nom + '">' + esc(libelle) +
      (requis ? ' *' : '') + '</label><div class="select"><select class="select__select" id="PbsD-' + nom + '" name="' + nom + '"' +
      (requis ? ' required' : '') + '>' + o + '</select><span class="svg-wrapper"><svg aria-hidden="true" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg></span></div></div>';
  }

  function cases(nom, valeurs, libelles, toutCoche) {
    return '<div class="pbs-demande__cases" data-groupe="' + nom + '">' + valeurs.map(function (v, i) {
      return '<label class="pbs-demande__case"><input type="checkbox" name="' + nom + '" value="' + esc(v) + '"' +
        (toutCoche ? ' checked' : '') + '><span>' + esc(libelles[i]) + '</span></label>';
    }).join('') + '</div>';
  }

  function blocPhotos(type) {
    var lib = type === 'Retour' ? T.photos_retour : type === 'Probleme' ? T.photos_probleme : T.photos_option;
    return '<div class="pbs-demande__champ"><span class="pbs-demande__label">' + esc(lib) + '</span>' +
      '<label class="pbs-demande__depot"><input type="file" name="photos" accept="image/*,application/pdf" multiple hidden>' +
      '<span class="button button--secondary">' + esc(T.ajouter_photos) + '</span></label>' +
      '<div class="pbs-demande__vignettes"></div></div>';
  }

  function piege() {
    return '<div class="pbs-demande__piege" aria-hidden="true"><input type="text" name="site_web" tabindex="-1" autocomplete="off"></div>';
  }

  function erreur(msg) {
    var z = $('.pbs-demande__erreur');
    if (z) { z.textContent = msg || ''; z.hidden = !msg; if (msg) z.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
  }

  // ── Étapes ────────────────────────────────────────────────────────────────
  function choix() {
    var cartes = Object.keys(T.types).map(function (k) {
      return '<button type="button" class="pbs-demande__carte" data-type="' + k + '">' + icone(k) +
        '<span class="pbs-demande__carte-texte"><strong>' + esc(T.types[k][0]) + '</strong>' +
        (T.types[k][1] ? '<span>' + esc(T.types[k][1]) + '</span>' : '') + '</span></button>';
    }).join('');
    afficher('<h2 class="pbs-demande__titre h3">' + esc(T.titre) + '</h2><div class="pbs-demande__cartes">' + cartes + '</div>');
  }

  function commande() {
    // Client connecté : ses commandes en liste, et la saisie du n° n'apparaît
    // que pour « Une autre commande » — la liste ET le champ, l'un sous
    // l'autre, demandaient deux fois la même chose (04/10/2026).
    var choixCmd = '', avecListe = MES_COMMANDES.length > 0;
    var connue = MES_COMMANDES.some(function (o) { return o.nom === etat.saisie; });
    if (avecListe) {
      var opts = MES_COMMANDES.map(function (o) { return o.nom; });
      var libs = MES_COMMANDES.map(function (o) { return o.nom + ' — ' + o.date; });
      choixCmd = liste('mes', T.mes_commandes, opts.concat(['autre']), libs.concat([T.autre_commande]), true);
    }
    var cacherSaisie = avecListe && (!etat.saisie || connue);
    afficher(retourBouton('choix') +
      '<h2 class="pbs-demande__titre h3">' + esc(T.types[etat.type][0]) + '</h2>' +
      '<form class="pbs-demande__form" novalidate>' + choixCmd +
      '<div class="pbs-demande__saisie"' + (cacherSaisie ? ' hidden' : '') + '>' +
      champ('commande', T.commande, { requis: true, valeur: etat.saisie, aide: T.commande_aide }) + '</div>' +
      champ('email', T.email, { requis: true, type: 'email', auto: 'email', valeur: etat.email }) +
      '<p class="pbs-demande__erreur" role="alert" hidden></p>' +
      '<div class="pbs-demande__actions"><button class="button" type="submit">' + esc(T.verifier) + '</button></div>' +
      '<div class="pbs-demande__quand-meme" hidden><button type="button" class="link" data-aller="details">' +
      esc(T.envoyer_quand_meme) + '</button></div></form>');
    var sel = $('#PbsD-mes');
    if (sel) {
      if (connue) sel.value = etat.saisie;
      else if (etat.saisie) sel.value = 'autre';
      sel.addEventListener('change', function () {
        var autre = sel.value === 'autre';
        $('.pbs-demande__saisie').hidden = !autre;
        $('#PbsD-commande').value = autre ? '' : sel.value;
        if (autre) $('#PbsD-commande').focus();
      });
    }
    $('.pbs-demande__form').addEventListener('submit', function (e) {
      e.preventDefault();
      var num = $('#PbsD-commande').value.trim();
      var mail = $('#PbsD-email').value.trim();
      if (!num || !mail) return erreur(T.obligatoire);
      etat.saisie = num; etat.email = mail;
      var bouton = e.target.querySelector('[type=submit]');
      bouton.disabled = true; bouton.textContent = T.verif;
      appeler('/commande', { commande: num, email: mail, type: etat.type, langue: LANGUE })
        .then(function (r) {
          if (r.ok) { etat.cmd = r.commande; etat.elig = r.eligibilite; return details(); }
          erreur(r.message || r.erreur || T.erreur_reseau);
          bouton.disabled = false; bouton.textContent = T.verifier;
          // Un suivi dont le n° est mal tapé peut quand même partir : on
          // préfère un message à vérifier qu'un client sans réponse.
          if (etat.type === 'Suivi' && r.motif === 'introuvable') $('.pbs-demande__quand-meme').hidden = false;
        })
        .catch(function () {
          erreur(T.erreur_reseau); bouton.disabled = false; bouton.textContent = T.verifier;
        });
    });
  }

  function resumeCommande() {
    var c = etat.cmd;
    if (!c) return '';
    var lignes = '<strong>' + esc(c.commande) + '</strong>';
    if (c.livree) lignes += ' · ' + esc(fmt(T.livree, { date: dateFr(c.livree) }));
    else if (c.expediee) lignes += ' · ' + esc(fmt(T.expediee, { date: dateFr(c.expediee) }));
    return '<div class="pbs-demande__commande">' + lignes + '</div>';
  }

  function details() {
    var t = etat.type, c = etat.cmd, corps = '';
    var articles = c && c.articles.length > 1
      ? '<div class="pbs-demande__champ"><span class="pbs-demande__label">' + esc(T.articles) + ' *</span>' +
        cases('articles', c.articles.map(function (a) { return (a.qte > 1 ? a.qte + '× ' : '') + a.titre; }),
              c.articles.map(function (a) { return (a.qte > 1 ? a.qte + '× ' : '') + a.titre; }), false) + '</div>'
      : '';
    var identite = '<div class="contact__fields">' + champ('nom', T.nom, { auto: 'name', valeur: etat.nom }) +
      (AVEC_COMMANDE.indexOf(t) >= 0 ? '' : champ('email', T.email_simple, { requis: true, type: 'email', auto: 'email', valeur: etat.email })) +
      '</div>';

    if (t === 'Suivi') {
      if (c) {
        if (c.suivis.length) {
          corps += '<div class="pbs-demande__suivis">' + c.suivis.map(function (s) {
            return '<a class="button" href="' + esc(s.url) + '" target="_blank" rel="noopener">' + esc(T.suivre) +
              (s.transporteur ? ' · ' + esc(s.transporteur) : '') + '</a>';
          }).join('') + '</div>';
        } else {
          corps += '<p class="pbs-demande__aide">' + esc(T.pas_expediee) + '</p>';
        }
        corps += '<details class="pbs-demande__plus"><summary>' + esc(T.souci_suivi) + '</summary>';
      }
      corps += liste('souci', T.souci, SOUCIS, T.soucis, true) + identite +
        champ('message', T.message, { zone: true, requis: true }) + (c ? '</details>' : '');
    } else if (t === 'Retour') {
      corps += articles + liste('motif', T.motif, MOTIFS_RETOUR, T.motifs_retour, true) +
        '<div class="pbs-demande__champ"><span class="pbs-demande__label">' + esc(T.conditions) + '</span>' +
        cases('conditions', ['etat_neuf', 'emballage', 'complet', 'frais'],
              [T.cond_neuf, T.cond_emballage, T.cond_complet, T.cond_frais], false) +
        '<a class="link pbs-demande__note" href="' + esc(racine.dataset.politique) + '" target="_blank">' + esc(T.politique) + '</a></div>' +
        blocPhotos(t) + identite + champ('message', T.message_option, { zone: true });
    } else if (t === 'Probleme') {
      corps += articles + liste('nature', T.nature, NATURES, T.natures, true) +
        cases('colis', ['oui'], [T.colis_abime], false) + blocPhotos(t) + identite +
        champ('message', T.message_option, { zone: true });
    } else if (t === 'Produit') {
      corps += champ('produit', T.produit, { valeur: etat.produit || '' }) + identite +
        champ('message', T.message, { zone: true, requis: true }) + blocPhotos(t);
    } else if (t === 'Reprise') {
      corps += champ('message', T.pieces, { zone: true, requis: true }) +
        '<div class="contact__fields">' + liste('etat', T.etat, ETATS, T.etats, false) + champ('prix', T.prix) + '</div>' +
        blocPhotos(t) + identite;
    } else {
      corps += identite + champ('commande', T.commande, { valeur: etat.saisie }) +
        champ('message', T.message, { zone: true, requis: true }) + blocPhotos(t);
    }

    var precedent = AVEC_COMMANDE.indexOf(t) >= 0 ? 'commande' : 'choix';
    afficher(retourBouton(precedent) + '<h2 class="pbs-demande__titre h3">' + esc(T.types[t][0]) + '</h2>' +
      resumeCommande() + '<form class="pbs-demande__form" novalidate>' + corps + piege() +
      '<p class="pbs-demande__erreur" role="alert" hidden></p>' +
      '<div class="pbs-demande__actions"><button class="button" type="submit">' + esc(T.envoyer) + '</button>' +
      '<small class="pbs-demande__note">' + esc(T.rgpd) + '</small></div></form>');

    var fichier = $('input[type=file]');
    if (fichier) fichier.addEventListener('change', function () { ajouterPhotos(fichier.files); fichier.value = ''; });
    vignettes();
    $('.pbs-demande__form').addEventListener('submit', envoyer);
  }

  // ── Photos ────────────────────────────────────────────────────────────────
  // Réduites dans le navigateur avant l'envoi : une photo de téléphone fait
  // 4 à 8 Mo, 1800 px suffisent pour juger d'une rayure, et l'envoi passe
  // alors sur une connexion mobile moyenne.
  function ajouterPhotos(liste_) {
    Array.prototype.slice.call(liste_).slice(0, 6 - etat.photos.length).forEach(function (f) {
      reduire(f).then(function (p) { etat.photos.push(p); vignettes(); });
    });
  }

  function reduire(f) {
    return new Promise(function (ok) {
      var brut = function () {
        var r = new FileReader();
        r.onload = function () { ok({ nom: f.name, type: f.type || 'application/octet-stream', contenu: String(r.result).split(',')[1], apercu: '' }); };
        r.readAsDataURL(f);
      };
      if (!/^image\/(jpeg|png|webp)$/.test(f.type) || !window.createImageBitmap) return brut();
      createImageBitmap(f).then(function (img) {
        var k = Math.min(1, COTE_MAX / Math.max(img.width, img.height));
        var cv = document.createElement('canvas');
        cv.width = Math.round(img.width * k); cv.height = Math.round(img.height * k);
        cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
        var url = cv.toDataURL('image/jpeg', 0.82);
        ok({ nom: f.name.replace(/\.\w+$/, '') + '.jpg', type: 'image/jpeg', contenu: url.split(',')[1], apercu: url });
      }).catch(brut);
    });
  }

  function vignettes() {
    var z = $('.pbs-demande__vignettes');
    if (!z) return;
    z.innerHTML = etat.photos.map(function (p, i) {
      return '<span class="pbs-demande__vignette">' + (p.apercu ? '<img src="' + p.apercu + '" alt="">' : '<span>' + esc(p.nom) + '</span>') +
        '<button type="button" data-retirer="' + i + '" aria-label="×">×</button></span>';
    }).join('');
  }

  // ── Envoi ─────────────────────────────────────────────────────────────────
  function valeur(nom) {
    var el = racine.querySelector('[name="' + nom + '"]');
    return el ? String(el.value || '').trim() : '';
  }
  function coches(nom) {
    return $$('input[name="' + nom + '"]:checked').map(function (x) { return x.value; });
  }

  function envoyer(e) {
    e.preventDefault();
    var form = e.target, t = etat.type;
    var manquant = Array.prototype.slice.call(form.querySelectorAll('[required]')).filter(function (x) {
      return x.offsetParent !== null && !String(x.value || '').trim();
    });
    if (manquant.length) { manquant[0].focus(); return erreur(T.obligatoire); }
    if (t === 'Retour' && coches('conditions').length < 4) return erreur(T.cocher);
    if (PHOTOS_OBLIGATOIRES.indexOf(t) >= 0 && !etat.photos.length) return erreur(T.photo_requise);
    var art = coches('articles');
    if (etat.cmd && etat.cmd.articles.length === 1) art = [etat.cmd.articles[0].titre];

    var champs = {
      type: t, langue: LANGUE,
      nom: valeur('nom') || etat.nom, email: valeur('email') || etat.email,
      commande: etat.cmd ? etat.cmd.commande : (valeur('commande') || etat.saisie),
      produit: valeur('produit'), message: valeur('message'),
      articles: art.join(' ; '), motif: valeur('motif'), nature: valeur('nature'),
      souci: valeur('souci'), etat: valeur('etat'), prix: valeur('prix'),
      colis_abime: coches('colis').length ? 'oui' : ''
    };
    coches('conditions').forEach(function (c) { champs[c] = 'oui'; });

    var bouton = form.querySelector('[type=submit]');
    bouton.disabled = true; bouton.textContent = T.envoi; erreur('');
    appeler('', {
      champs: champs, site_web: valeur('site_web'),
      fichiers: etat.photos.map(function (p) { return { nom: p.nom, type: p.type, contenu: p.contenu }; })
    }).then(function (r) {
      if (r.num) return fini(r.num, champs.email);
      erreur(r.erreur || T.erreur_reseau); bouton.disabled = false; bouton.textContent = T.envoyer;
    }).catch(function () {
      erreur(T.erreur_reseau); bouton.disabled = false; bouton.textContent = T.envoyer;
    });
  }

  function fini(num, email) {
    afficher('<div class="pbs-demande__fini"><h2 class="h3">' + esc(fmt(T.fini_titre, { num: num })) + '</h2>' +
      '<p>' + esc(fmt(T.fini, { num: num, email: email })) + '</p>' +
      (etat.type === 'Retour' ? '<p class="pbs-demande__aide">' + esc(T.fini_retour) + '</p>' : '') + '</div>');
  }

  function appeler(chemin, corps) {
    return fetch(API + chemin, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corps)
    }).then(function (r) {
      return r.json().catch(function () { return { erreur: T.erreur_reseau }; });
    });
  }

  // ── Navigation ────────────────────────────────────────────────────────────
  function aller(ou) {
    if (ou === 'choix') { etat.cmd = null; etat.photos = []; return choix(); }
    if (ou === 'commande') return commande();
    if (ou === 'details') { etat.cmd = null; return details(); }
  }

  function demarrer(type) {
    etat.type = type; etat.cmd = null; etat.photos = [];
    if (AVEC_COMMANDE.indexOf(type) >= 0) return commande();
    details();
  }

  racine.addEventListener('click', function (e) {
    var b = e.target.closest('[data-type],[data-aller],[data-retirer]');
    if (!b) return;
    if (b.dataset.type) return demarrer(b.dataset.type);
    if (b.dataset.aller) return aller(b.dataset.aller);
    if (b.dataset.retirer) { etat.photos.splice(+b.dataset.retirer, 1); return vignettes(); }
  });

  // Liens directs : ?type=Retour, ?type=Produit&produit=…, ?commande=#1289.
  // Le mail de confirmation de commande porte aussi ?email= : le client
  // arrive avec sa commande déjà remplie, il n'a plus qu'à choisir.
  var q = new URLSearchParams(window.location.search);
  etat.produit = q.get('produit') || '';
  etat.saisie = q.get('commande') || '';
  if (q.get('email')) etat.email = q.get('email');
  if (q.get('type') && T.types[q.get('type')]) {
    demarrer(q.get('type'));
    // Venu d'un mail de commande avec n° ET e-mail : on lance la recherche
    // tout de suite — un suivi s'affiche alors sans un seul clic.
    var f = $('.pbs-demande__form');
    if (f && etat.saisie && etat.email && $('#PbsD-commande')) f.requestSubmit();
  } else {
    choix();
  }
})();
